<div class="bg-main-container border-bottom d-flex justify-content-between align-items-center p-3">
  <h5 class="text-white mb-0">Event Details</h5>
  <div [innerHtml]="SVG_ICONS.CLOSE_ICON() | sanitizer : 'html'" role="button" (click)="onClose()"></div>
</div>

<div class="bg-main-container p-4 scrollable-content font-white" *ngIf="eventData">
  <div class="row mb-4">
    <div class="d-flex justify-content-between mb-3">
      <div class="">
        <h3 class="text-primary fw-bold">{{ eventData.EventName }}</h3>
        <p class="font-gray-opacity">{{ eventData.EventDescription }}</p>
      </div>
      <div
        [innerHTML]="SVG_ICONS.GET_REPORT_ICON() | sanitizer : 'html'"
        matTooltip="Download Excel"
        matTooltipPosition="below"
        matTooltipShowDelay="0"
        class="cursor-pointer"
        (click)="downloadReport()"></div>
    </div>

    <div class="col-md-6 mb-3">
      <div class="d-flex align-items-center mb-2">
        <span class="fw-bold me-2 font-gray-opacity">Type : </span>
        <span class="font-white">{{ eventData.EventType }}</span>
      </div>
      <div class="d-flex align-items-center mb-2">
        <span class="fw-bold me-2 font-gray-opacity">Venue : </span>
        <span class="font-white">{{ eventData.Venue }}, {{ eventData.City }}</span>
      </div>
      <div class="d-flex align-items-center mb-2">
        <span class="fw-bold me-2 font-gray-opacity">Fee : </span>
        <span class="font-white">{{ eventData.RegistrationFee | currency : "INR" }}</span>
      </div>
    </div>

    <div class="col-md-6 mb-3">
      <div class="d-flex align-items-center mb-2">
        <span class="fw-bold me-2 font-gray-opacity">Start Date : </span>
        <span class="font-white">{{ eventData.StartDate | date : "dd/MM/yyyy" }}</span>
      </div>
      <div class="d-flex align-items-center mb-2">
        <span class="fw-bold me-2 font-gray-opacity">End Date : </span>
        <span class="font-white">{{ eventData.EndDate | date : "dd/MM/yyyy" }}</span>
      </div>
      <div class="d-flex align-items-center mb-2">
        <span class="fw-bold me-2 font-gray-opacity">Reg. Last Date : </span>
        <span class="font-white">{{ eventData.RegistrationLastDate | date : "dd/MM/yyyy" }}</span>
      </div>
    </div>
  </div>

  <div class="border-bottom border-secondary mb-4"></div>

  <div class="row">
    <div class="col-12">
      <h5 class="font-white mb-3">Participants</h5>

      <div class="table-responsive" *ngIf="participants.length > 0; else noParticipants">
        <table mat-table [dataSource]="dataSource" class="w-100 custom-table">
          <ng-container matColumnDef="StudentName">
            <th mat-header-cell *matHeaderCellDef class="font-gray-opacity">Student Name</th>
            <td mat-cell *matCellDef="let element" class="font-white">{{ element.StudentName }}</td>
          </ng-container>

          <ng-container matColumnDef="MobileNo">
            <th mat-header-cell *matHeaderCellDef class="font-gray-opacity">Mobile No</th>
            <td mat-cell *matCellDef="let element" class="font-white">{{ element.MobileNo }}</td>
          </ng-container>

          <ng-container matColumnDef="Gender">
            <th mat-header-cell *matHeaderCellDef class="font-gray-opacity">Gender</th>
            <td mat-cell *matCellDef="let element" class="font-white">{{ element.Gender }}</td>
          </ng-container>

          <ng-container matColumnDef="DOB">
            <th mat-header-cell *matHeaderCellDef class="font-gray-opacity">DOB</th>
            <td mat-cell *matCellDef="let element" class="font-white">{{ element.DOB | date : "dd/MM/yyyy" }}</td>
          </ng-container>

          <ng-container matColumnDef="City">
            <th mat-header-cell *matHeaderCellDef class="font-gray-opacity">City</th>
            <td mat-cell *matCellDef="let element" class="font-white">{{ element.City }}</td>
          </ng-container>

          <ng-container matColumnDef="State">
            <th mat-header-cell *matHeaderCellDef class="font-gray-opacity">State</th>
            <td mat-cell *matCellDef="let element" class="font-white">{{ element.State }}</td>
          </ng-container>

          <!-- <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef class="font-gray-opacity">Status</th>
            <td mat-cell *matCellDef="let element">
              <span class="badge" [ngClass]="element.IsActive ? 'bg-success' : 'bg-danger'">
                {{ element.IsActive ? "Active" : "Inactive" }}
              </span>
            </td>
          </ng-container> -->

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <ng-template #noParticipants>
        <div class="alert alert-info bg-dark font-gray-opacity border-secondary">No participants registered for this event yet.</div>
      </ng-template>
    </div>
  </div>
</div>
